<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M15 3.00005 9 7.96601V21.0001l6-4.966V3.00005ZM4.13375 5.34197c-.17481-.16327-.39752-.27445-.63996-.31949-.24244-.04504-.49373-.02191-.72211.06645-.22837.08837-.42358.23801-.56093.43-.13736.192-.2107.41773-.21075.64866v9.67781c.00007.3097.13181.6067.36625.8257L7 21.0001V7.96601L4.13375 5.34197Zm17.50005.33557L17 3v13.034l2.8662 1.9726c.1749.1633.3976.2745.64.3195.2425.0451.4937.0219.7221-.0664.2284-.0884.4236-.238.561-.43.1373-.192.2106-.4177.2107-.6487V6.50316c-.0001-.30969-.1318-.60667-.3662-.82562Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M14.5528 3.10557c.2815-.14077.6129-.14076.8945.00004l5.4467 2.72386c.3322.16598.6116.42115.8069.73694.1953.3158.2989.67974.2991 1.05106V18.382c-.0002.3408-.0874.6764-.2535.974-.166.2976-.4054.5478-.6953.7269-.2899.1791-.6208.2812-.9612.2965-.3405.0154-.6792-.0565-.984-.2089L15 18.118l-5.55279 2.7764c-.28155.1408-.61295.1408-.89449 0L3.106 18.1705c-.33216-.1659-.61156-.4211-.8069-.7369-.19533-.3158-.2989-.6797-.2991-1.0511V5.618c.00018-.34078.08744-.6764.25349-.97399.16605-.29759.40539-.54782.6953-.72693.28991-.17912.62078-.28119.96122-.29652.34044-.01533.67915.05658.98399.20891l4.10595 2.05252 5.55285-2.77642ZM8 7.61809 4 5.61853V16.3815l4 2.0003V7.61809ZM10 18.382l4-2V5.61803l-4 2V18.382Zm6-12.76383V16.3819l4 1.9996V7.61853l-4-2.00036Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
